import type { ModelEvent } from "@tsmono/inspect-common/types";

/**
 * Best-effort duration in seconds for a single ModelEvent attempt.
 *
 * Falls back to (completed - timestamp) when neither `output.time` nor
 * `working_time` is set (typical for failed attempts whose duration must
 * be inferred from start/end timestamps). Returns `null` when no
 * dependable duration can be derived.
 */
export function attemptDurationSec(event: ModelEvent): number | null {
  const explicit = event.output.time ?? event.working_time;
  if (typeof explicit === "number" && !Number.isNaN(explicit)) {
    return explicit;
  }
  if (event.timestamp && event.completed) {
    const start = Date.parse(event.timestamp);
    const end = Date.parse(event.completed);
    if (Number.isFinite(start) && Number.isFinite(end) && end >= start) {
      return (end - start) / 1000;
    }
  }
  return null;
}
